export interface CategoryUiModel {
  id: number;
  code: string;
  label: string;
  img: string;
}

export class Categories {
  public static get(): Array<CategoryUiModel> {
    return [
      {
        id: 1,
        code: 'PT_UNSAFE_PATH',
        img: 'assets/svg/categories/1.svg',
        label: 'Unsafe pedestrian or bicycle'
      },
      {
        id: 2,
        code: 'PT_MISSING_PATH',
        img: 'assets/svg/categories/2.svg',
        label: 'Absence of pedestrian or bicycle path'
      },
      {
        id: 3,
        code: 'PT_UNSAFE_CROSSING',
        img: 'assets/svg/categories/3.svg',
        label: 'Unsafe crosswalk'
      },
      {
        id: 4,
        code: 'PT_MISSING_CROSSING',
        img: 'assets/svg/categories/4.svg',
        label: 'Absence of a crosswalk'
      },
      {
        id: 5,
        code: 'PT_DANGUREOUS_INTERSECTION',
        img: 'assets/svg/categories/5.svg',
        label: 'Dangerous intersection'
      },
      {
        id: 6,
        code: 'PT_BAD_ROAD',
        img: 'assets/svg/categories/6.svg',
        label: 'Bad road surface'
      },
      {
        id: 7,
        code: 'PT_POOR_VISIBILITY',
        img: 'assets/svg/categories/7.svg',
        label: 'Poor visibility'
      },
      {
        id: 8,
        code: 'PT_PEOPLE_BEHAVIOR',
        img: 'assets/svg/categories/8.svg',
        label: 'Traffic behavior'
      },
      {
        id: 9,
        code: 'PT_FAST_TRAFFIC',
        img: 'assets/svg/categories/9.svg',
        label: 'Over speed'
      },
      {
        id: 10,
        code: 'PT_GATHERING_PLACE',
        img: 'assets/svg/categories/10.svg',
        label: 'Gathering place'
      },
      {
        id: 11,
        code: 'PT_OTHER',
        img: 'assets/svg/categories/11.svg',
        label: 'Others'
      }
    ];
  }

  public static valueOf(code: string): CategoryUiModel {
    return this.get().find(it => it.code === code);
  }
}
